import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { UserIdleService } from 'angular-user-idle';
import { Subscription } from 'rxjs';

import { InactiveModalComponent } from './inactive-modal.component';
import themes from 'devextreme/ui/themes';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  private timerSubscriber: Subscription;
  constructor(
	private modalService: NgbModal) {
  }

  ngOnInit() {
	// themes.current("generic.light.compact");
	this.startIdleWatch();
  }

  openReportModal() {
	this.timerSubscriber.unsubscribe();
	const modalRef = this.modalService.open(InactiveModalComponent);
	modalRef.componentInstance.countNum = 900;
	modalRef.result.then(result => {
		// onclose
		if (result === 'cancel') {
		// this.userIdle.resetTimer();
		this.startIdleWatch();
		}
	}, (reason) => {
		// ondismiss
		// this.userIdle.resetTimer();
		this.startIdleWatch();
	});
  }

  startIdleWatch() {
	// Start watching for user inactivity.
	// this.userIdle.startWatching();

	// Start watching when user idle is starting.
	// this.timerSubscriber = this.userIdle.onTimerStart().subscribe(count => this.openReportModal());

	// Start watch when time is up.
	// this.userIdle.onTimeout().subscribe(() => console.log('Time is up!'));
  }

}
